export const data = {
  "1-M-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1-M-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1-M-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1-M-BLK-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1-M-BLK-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1-M-BLK-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1-M-BLK-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1-M-BLK-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1-M-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1-M-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1-M-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1-M-BRN-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1-M-BRN-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1-M-BRN-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1-M-BRN-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1-M-BRN-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1-W-BLK-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1-W-BLK-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1-W-BLK-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1-W-BLK-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1-W-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1-W-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1-W-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1-W-BRN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1-W-BRN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1-W-BRN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1-W-BRN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1-W-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1-W-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1-W-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1-W-GRY-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1-W-GRY-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1-W-GRY-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1-W-GRY-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1-W-GRY-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1-W-GRY-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1-W-GRY-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1-W-RED-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1-W-RED-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1-W-RED-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1-W-RED-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1-W-RED-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1-W-RED-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1-W-RED-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1-W-TAN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1-W-TAN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1-W-TAN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1-W-TAN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1-W-TAN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1-W-TAN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1-W-TAN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1-W-WHT-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1-W-WHT-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1-W-WHT-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1-W-WHT-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1-W-WHT-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1-W-WHT-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1-W-WHT-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1-W-HNY-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1-W-HNY-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1-W-HNY-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1-W-HNY-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1-W-HNY-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1-W-HNY-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1-W-HNY-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "10-M-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "10-M-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "10-M-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "10-M-BLK-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "10-M-BLK-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "10-M-BLK-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "10-M-BLK-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "10-M-BLK-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "10-M-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "10-M-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "10-M-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "10-M-BRN-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "10-M-BRN-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "10-M-BRN-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "10-M-BRN-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "10-M-BRN-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1000-W-BLK-36": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1000-W-BLK-37": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1000-W-BLK-38": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1000-W-BLK-39": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1000-W-BLK-40": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1000-W-BLK-41": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1000-W-BLK-42": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1000-W-BRN-36": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1000-W-BRN-37": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1000-W-BRN-38": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1000-W-BRN-39": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1000-W-BRN-40": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1000-W-BRN-41": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1000-W-BRN-42": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1000-W-HNY-36": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1000-W-HNY-37": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1000-W-HNY-38": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1000-W-HNY-39": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1000-W-HNY-40": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1000-W-HNY-41": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1000-W-HNY-42": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1000-W-SLVR-36": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1000-W-SLVR-37": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1000-W-SLVR-38": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1000-W-SLVR-39": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1000-W-SLVR-40": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1000-W-SLVR-41": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1000-W-SLVR-42": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1000-W-TAN-36": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1000-W-TAN-37": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1000-W-TAN-38": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1000-W-TAN-39": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1000-W-TAN-40": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1000-W-TAN-41": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1000-W-TAN-42": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1002-W-BLK-36": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1002-W-BLK-37": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1002-W-BLK-38": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1002-W-BLK-39": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1002-W-BLK-40": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1002-W-BLK-41": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1002-W-BLK-42": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1002-W-BRN-36": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1002-W-BRN-37": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1002-W-BRN-38": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1002-W-BRN-39": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1002-W-BRN-40": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1002-W-BRN-41": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1002-W-BRN-42": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1002-W-SLVR-36": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1002-W-SLVR-37": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1002-W-SLVR-38": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1002-W-SLVR-39": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1002-W-SLVR-40": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1002-W-SLVR-41": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1002-W-SLVR-42": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1002-W-TAN-36": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1002-W-TAN-37": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1002-W-TAN-38": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1002-W-TAN-39": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1002-W-TAN-40": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1002-W-TAN-41": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1002-W-TAN-42": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1003-W-BLK-36": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1003-W-BLK-37": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1003-W-BLK-38": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1003-W-BLK-39": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1003-W-BLK-40": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1003-W-BLK-41": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1003-W-BLK-42": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1003-W-BRN-36": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1003-W-BRN-37": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1003-W-BRN-38": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1003-W-BRN-39": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1003-W-BRN-40": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1003-W-BRN-41": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1003-W-BRN-42": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1003-W-TAN-36": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1003-W-TAN-37": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1003-W-TAN-38": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1003-W-TAN-39": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1003-W-TAN-40": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1003-W-TAN-41": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1003-W-TAN-42": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1004-W-BLK-36": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1004-W-BLK-37": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1004-W-BLK-38": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1004-W-BLK-39": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1004-W-BLK-40": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1004-W-BLK-41": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1004-W-BLK-42": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1004-W-TAN-36": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1004-W-TAN-37": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1004-W-TAN-38": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1004-W-TAN-39": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1004-W-TAN-40": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1004-W-TAN-41": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1004-W-TAN-42": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1005-W-BLK-36": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1005-W-BLK-37": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1005-W-BLK-38": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1005-W-BLK-39": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1005-W-BLK-40": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1005-W-BLK-41": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1005-W-BLK-42": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1005-W-BRN-36": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1005-W-BRN-37": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1005-W-BRN-38": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1005-W-BRN-39": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1005-W-BRN-40": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1005-W-BRN-41": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1005-W-BRN-42": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1005-W-TAN-36": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1005-W-TAN-37": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1005-W-TAN-38": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1005-W-TAN-39": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1005-W-TAN-40": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1005-W-TAN-41": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1005-W-TAN-42": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1006-W-BLK-36": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1006-W-BLK-37": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1006-W-BLK-38": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1006-W-BLK-39": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1006-W-BLK-40": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1006-W-BLK-41": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1006-W-BLK-42": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1006-W-BRN-36": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1006-W-BRN-37": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1006-W-BRN-38": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1006-W-BRN-39": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1006-W-BRN-40": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1006-W-BRN-41": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1006-W-BRN-42": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1006-W-HNY-36": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1006-W-HNY-37": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1006-W-HNY-38": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1006-W-HNY-39": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1006-W-HNY-40": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1006-W-HNY-41": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1006-W-HNY-42": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1006-W-TAN-36": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1006-W-TAN-37": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1006-W-TAN-38": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1006-W-TAN-39": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1006-W-TAN-40": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1006-W-TAN-41": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1006-W-TAN-42": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1007-W-BLK-36": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1007-W-BLK-37": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1007-W-BLK-38": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1007-W-BLK-39": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1007-W-BLK-40": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1007-W-BLK-41": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1007-W-BLK-42": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1007-W-BRN-36": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1007-W-BRN-37": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1007-W-BRN-38": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1007-W-BRN-39": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1007-W-BRN-40": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1007-W-BRN-41": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1007-W-BRN-42": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1007-W-TAN-36": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1007-W-TAN-37": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1007-W-TAN-38": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1007-W-TAN-39": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1007-W-TAN-40": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1007-W-TAN-41": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1007-W-TAN-42": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1008-W-BLK-36": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1008-W-BLK-37": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1008-W-BLK-38": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1008-W-BLK-39": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1008-W-BLK-40": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1008-W-BLK-41": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1008-W-BLK-42": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1008-W-BRN-36": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1008-W-BRN-37": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1008-W-BRN-38": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1008-W-BRN-39": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1008-W-BRN-40": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1008-W-BRN-41": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1008-W-BRN-42": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1008-W-TAN-36": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1008-W-TAN-37": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1008-W-TAN-38": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1008-W-TAN-39": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1008-W-TAN-40": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1008-W-TAN-41": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1008-W-TAN-42": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1009-W-TAN-36": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1009-W-TAN-37": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1009-W-TAN-38": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1009-W-TAN-39": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1009-W-TAN-40": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1009-W-TAN-41": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1009-W-TAN-42": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1009-W-VIO-36": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1009-W-VIO-37": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1009-W-VIO-38": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1009-W-VIO-39": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1009-W-VIO-40": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1009-W-VIO-41": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1009-W-VIO-42": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1013-W-BLK-36": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1013-W-BLK-37": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1013-W-BLK-38": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1013-W-BLK-39": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1013-W-BLK-40": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1013-W-BLK-41": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1013-W-BLK-42": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1013-W-BRN-36": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1013-W-BRN-37": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1013-W-BRN-38": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1013-W-BRN-39": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1013-W-BRN-40": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1013-W-BRN-41": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1013-W-BRN-42": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1013-W-TAN-36": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1013-W-TAN-37": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1013-W-TAN-38": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1013-W-TAN-39": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1013-W-TAN-40": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1013-W-TAN-41": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1013-W-TAN-42": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1014-W-BLK-36": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1014-W-BLK-37": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1014-W-BLK-38": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1014-W-BLK-39": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1014-W-BLK-40": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1014-W-BLK-41": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1014-W-BLK-42": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1014-W-BRN-36": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1014-W-BRN-37": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1014-W-BRN-38": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1014-W-BRN-39": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1014-W-BRN-40": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1014-W-BRN-41": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1014-W-BRN-42": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1014-W-TAN-36": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1014-W-TAN-37": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1014-W-TAN-38": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1014-W-TAN-39": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1014-W-TAN-40": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1014-W-TAN-41": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1014-W-TAN-42": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1015CT-W-BLK-36": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "1015CT-W-BLK-37": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "1015CT-W-BLK-38": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "1015CT-W-BLK-39": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "1015CT-W-BLK-40": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "1015CT-W-BLK-41": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "1015CT-W-BLK-42": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "1015CT-W-BRN-36": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "1015CT-W-BRN-37": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "1015CT-W-BRN-38": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "1015CT-W-BRN-39": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "1015CT-W-BRN-40": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "1015CT-W-BRN-41": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "1015CT-W-BRN-42": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "1015CT-W-TAN-36": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "1015CT-W-TAN-37": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "1015CT-W-TAN-38": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "1015CT-W-TAN-39": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "1015CT-W-TAN-40": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "1015CT-W-TAN-41": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "1015CT-W-TAN-42": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "1015CT-W-TUR-36": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "1015CT-W-TUR-37": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "1015CT-W-TUR-38": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "1015CT-W-TUR-39": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "1015CT-W-TUR-40": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "1015CT-W-TUR-41": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "1015CT-W-TUR-42": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "1016-M-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1016-M-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1016-M-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1016-M-BLK-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1016-M-BLK-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1016-M-BLK-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1016-M-BLK-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1016-M-BLK-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1016-M-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1016-M-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1016-M-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1016-M-BRN-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1016-M-BRN-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1016-M-BRN-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1016-M-BRN-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1016-M-BRN-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1017-M-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1017-M-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1017-M-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1017-M-BLK-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1017-M-BLK-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1017-M-BLK-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1017-M-BLK-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1017-M-BLK-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1017-M-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1017-M-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1017-M-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1017-M-BRN-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1017-M-BRN-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1017-M-BRN-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1017-M-BRN-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1017-M-BRN-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1017-M-HNY-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1017-M-HNY-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1017-M-HNY-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1017-M-HNY-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1017-M-HNY-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1017-M-HNY-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1017-M-HNY-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1017-M-HNY-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1020-M-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1020-M-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1020-M-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1020-M-BLK-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1020-M-BLK-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1020-M-BLK-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1020-M-BLK-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1020-M-BLK-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1020-M-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1020-M-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1020-M-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1020-M-BRN-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1020-M-BRN-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1020-M-BRN-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1020-M-BRN-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1020-M-BRN-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1021-W-BRN-36": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1021-W-BRN-37": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1021-W-BRN-38": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1021-W-BRN-39": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1021-W-BRN-40": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1021-W-BRN-41": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1021-W-BRN-42": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1021-W-TAN-36": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1021-W-TAN-37": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1021-W-TAN-38": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1021-W-TAN-39": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1021-W-TAN-40": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1021-W-TAN-41": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1021-W-TAN-42": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1022-W-BLK-36": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1022-W-BLK-37": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1022-W-BLK-38": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1022-W-BLK-39": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1022-W-BLK-40": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1022-W-BLK-41": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1022-W-BLK-42": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1022-W-BRN-36": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1022-W-BRN-37": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1022-W-BRN-38": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1022-W-BRN-39": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1022-W-BRN-40": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1022-W-BRN-41": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1022-W-BRN-42": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1022-W-TAN-36": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1022-W-TAN-37": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1022-W-TAN-38": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1022-W-TAN-39": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1022-W-TAN-40": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1022-W-TAN-41": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1022-W-TAN-42": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1023-M-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1023-M-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1023-M-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1023-M-BLK-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1023-M-BLK-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1023-M-BLK-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1023-M-BLK-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1023-M-BLK-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1023-M-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1023-M-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1023-M-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1023-M-BRN-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1023-M-BRN-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1023-M-BRN-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1023-M-BRN-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1023-M-BRN-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1024-W-BLK-36": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1024-W-BLK-37": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1024-W-BLK-38": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1024-W-BLK-39": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1024-W-BLK-40": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1024-W-BLK-41": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1024-W-BLK-42": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1024-W-BRN-36": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1024-W-BRN-37": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1024-W-BRN-38": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1024-W-BRN-39": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1024-W-BRN-40": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1024-W-BRN-41": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1024-W-BRN-42": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1029-W-BLK-36": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1029-W-BLK-37": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1029-W-BLK-38": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1029-W-BLK-39": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1029-W-BLK-40": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1029-W-BLK-41": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1029-W-BLK-42": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1029-W-HNY-36": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1029-W-HNY-37": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1029-W-HNY-38": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1029-W-HNY-39": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1029-W-HNY-40": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1029-W-HNY-41": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1029-W-HNY-42": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1031-W-BLK-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1031-W-BLK-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1031-W-BLK-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1031-W-BLK-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1031-W-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1031-W-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1031-W-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1031-W-BRN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1031-W-BRN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1031-W-BRN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1031-W-BRN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1031-W-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1031-W-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1031-W-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1031-W-TAN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1031-W-TAN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1031-W-TAN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1031-W-TAN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1031-W-TAN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1031-W-TAN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1031-W-TAN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1032-W-BLK-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1032-W-BLK-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1032-W-BLK-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1032-W-BLK-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1032-W-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1032-W-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1032-W-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1032-W-BRN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1032-W-BRN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1032-W-BRN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1032-W-BRN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1032-W-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1032-W-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1032-W-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1034-W-BLK-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1034-W-BLK-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1034-W-BLK-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1034-W-BLK-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1034-W-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1034-W-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1034-W-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1034-W-BRN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1034-W-BRN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1034-W-BRN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1034-W-BRN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1034-W-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1034-W-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1034-W-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1034-W-HNY-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1034-W-HNY-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1034-W-HNY-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1034-W-HNY-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1034-W-HNY-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1034-W-HNY-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1034-W-HNY-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1034B-W-BRNNU-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1034B-W-BRNNU-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1034B-W-BRNNU-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1034B-W-BRNNU-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1034B-W-BRNNU-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1034B-W-BRNNU-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1034B-W-BRNNU-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1034B-W-OILBRN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1034B-W-OILBRN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1034B-W-OILBRN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1034B-W-OILBRN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1034B-W-OILBRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1034B-W-OILBRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1034B-W-OILBRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1034B-W-TANNU-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1034B-W-TANNU-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1034B-W-TANNU-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1034B-W-TANNU-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1034B-W-TANNU-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1034B-W-TANNU-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1034B-W-TANNU-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1035-W-BRN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1035-W-BRN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1035-W-BRN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1035-W-BRN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1035-W-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1035-W-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1035-W-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1036-W-BRN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1036-W-BRN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1036-W-BRN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1036-W-BRN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1036-W-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1036-W-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1036-W-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1037-W-BRN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1037-W-BRN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1037-W-BRN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1037-W-BRN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1037-W-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1037-W-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1037-W-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1038-W-BRN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1038-W-BRN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1038-W-BRN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1038-W-BRN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1038-W-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1038-W-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1038-W-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "104-M-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "104-M-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "104-M-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "104-M-BLK-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "104-M-BLK-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "104-M-BLK-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "104-M-BLK-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "104-M-BLK-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "104-M-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "104-M-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "104-M-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "104-M-BRN-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "104-M-BRN-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "104-M-BRN-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "104-M-BRN-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "104-M-BRN-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "104-M-HNY-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "104-M-HNY-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "104-M-HNY-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "104-M-HNY-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "104-M-HNY-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "104-M-HNY-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "104-M-HNY-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "104-M-HNY-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "104-M-TAN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "104-M-TAN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "104-M-TAN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "104-M-TAN-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "104-M-TAN-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "104-M-TAN-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "104-M-TAN-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "104-M-TAN-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "104-M-WHT-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "104-M-WHT-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "104-M-WHT-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "104-M-WHT-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "104-M-WHT-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "104-M-WHT-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "104-M-WHT-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "104-M-WHT-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1040-M-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1040-M-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1040-M-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1040-M-BLK-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1040-M-BLK-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1040-M-BLK-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1040-M-BLK-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1040-M-BLK-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1040-M-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1040-M-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1040-M-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1040-M-BRN-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1040-M-BRN-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1040-M-BRN-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1040-M-BRN-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1040-M-BRN-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-M-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-M-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-M-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-M-BLK-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-M-BLK-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-M-BLK-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-M-BLK-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-M-BLK-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-M-BLKNU-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-M-BLKNU-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-M-BLKNU-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-M-BLKNU-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-M-BLKNU-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-M-BLKNU-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-M-BLKNU-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-M-BLKNU-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-M-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-M-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-M-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-M-BRN-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-M-BRN-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-M-BRN-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-M-BRN-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-M-BRN-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-M-BRNNU-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-M-BRNNU-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-M-BRNNU-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-M-BRNNU-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-M-BRNNU-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-M-BRNNU-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-M-BRNNU-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-M-BRNNU-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-M-OILBRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-M-OILBRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-M-OILBRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-M-OILBRN-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-M-OILBRN-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-M-OILBRN-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-M-OILBRN-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-M-OILBRN-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-M-TANNU-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-M-TANNU-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-M-TANNU-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-M-TANNU-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-M-TANNU-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-M-TANNU-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-M-TANNU-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-M-TANNU-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-M-WHTNU-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-M-WHTNU-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-M-WHTNU-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-M-WHTNU-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-M-WHTNU-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-M-WHTNU-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-M-WHTNU-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-M-WHTNU-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-M-YELNU-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-M-YELNU-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-M-YELNU-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-M-YELNU-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-M-YELNU-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-M-YELNU-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-M-YELNU-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-M-YELNU-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-W-BLKNU-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-W-BLKNU-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-W-BLKNU-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-W-BLKNU-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-W-BLKNU-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-W-BLKNU-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-W-BLKNU-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-W-BRN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-W-BRN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-W-BRN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-W-BRN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-W-BRNMG-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-W-BRNMG-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-W-BRNMG-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-W-BRNMG-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-W-BRNMG-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-W-BRNMG-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-W-BRNNU-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-W-BRNNU-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-W-BRNNU-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-W-BRNNU-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-W-BRNNU-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-W-BRNNU-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-W-BRNNU-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-W-TANNU-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-W-TANNU-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-W-TANNU-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-W-TANNU-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-W-TANNU-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-W-TANNU-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-W-TANNU-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-W-WHTNU-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-W-WHTNU-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-W-WHTNU-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-W-WHTNU-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-W-WHTNU-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-W-WHTNU-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-W-WHTNU-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-W-YELNU-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-W-YELNU-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-W-YELNU-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-W-YELNU-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-W-YELNU-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-W-YELNU-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1041-W-YELNU-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1043-M-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1043-M-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1043-M-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1043-M-BRN-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1043-M-BRN-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1043-M-BRN-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1043-M-BRN-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1043-M-BRN-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1044-M-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1044-M-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1044-M-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1044-M-BLK-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1044-M-BLK-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1044-M-BLK-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1044-M-BLK-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1044-M-BLK-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1044-M-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1044-M-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1044-M-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1044-M-BRN-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1044-M-BRN-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1044-M-BRN-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1044-M-BRN-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1044-M-BRN-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-M-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-M-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-M-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-M-BLK-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-M-BLK-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-M-BLK-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-M-BLK-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-M-BLK-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-M-BLKNU-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-M-BLKNU-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-M-BLKNU-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-M-BLKNU-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-M-BLKNU-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-M-BLKNU-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-M-BLKNU-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-M-BLKNU-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-M-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-M-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-M-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-M-BRN-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-M-BRN-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-M-BRN-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-M-BRN-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-M-BRN-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-M-BRNNU-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-M-BRNNU-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-M-BRNNU-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-M-BRNNU-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-M-BRNNU-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-M-BRNNU-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-M-BRNNU-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-M-BRNNU-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-M-OILBRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-M-OILBRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-M-OILBRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-M-OILBRN-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-M-OILBRN-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-M-OILBRN-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-M-OILBRN-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-M-OILBRN-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-M-TANNU-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-M-TANNU-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-M-TANNU-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-M-TANNU-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-M-TANNU-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-M-TANNU-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-M-TANNU-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-M-TANNU-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-M-TUR-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-M-TUR-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-M-TUR-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-M-TUR-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-M-TUR-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-M-TUR-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-M-TUR-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-M-TUR-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-M-WHTNU-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-M-WHTNU-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-M-WHTNU-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-M-WHTNU-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-M-WHTNU-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-M-WHTNU-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-M-WHTNU-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-M-WHTNU-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-M-YELNU-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-M-YELNU-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-M-YELNU-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-M-YELNU-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-M-YELNU-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-M-YELNU-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-M-YELNU-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-M-YELNU-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-W-BLKNU-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-W-BLKNU-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-W-BLKNU-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-W-BLKNU-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-W-BLKNU-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-W-BLKNU-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-W-BLKNU-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-W-BRN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-W-BRN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-W-BRN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-W-BRN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-W-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-W-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-W-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-W-BRNMG-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-W-BRNMG-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-W-BRNMG-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-W-BRNMG-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-W-BRNMG-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-W-BRNMG-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-W-BRNMG-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-W-BRNNU-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-W-BRNNU-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-W-BRNNU-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-W-BRNNU-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-W-BRNNU-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-W-BRNNU-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-W-BRNNU-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-W-TANNU-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-W-TANNU-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-W-TANNU-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-W-TANNU-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-W-TANNU-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-W-TANNU-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-W-TANNU-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-W-WHTNU-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-W-WHTNU-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-W-WHTNU-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-W-WHTNU-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-W-WHTNU-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-W-WHTNU-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-W-WHTNU-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-W-YELNU-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-W-YELNU-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-W-YELNU-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-W-YELNU-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-W-YELNU-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-W-YELNU-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1045-W-YELNU-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1051-M-TUR-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1051-M-TUR-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1051-M-TUR-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1051-M-TUR-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1051-M-TUR-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1051-M-TUR-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1051-M-TUR-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1051-M-TUR-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1046-M-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1046-M-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1046-M-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1046-M-BRN-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1046-M-BRN-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1046-M-BRN-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1046-M-BRN-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1046-M-BRN-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1054-M-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1054-M-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1054-M-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1054-M-BLK-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1054-M-BLK-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1054-M-BLK-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1054-M-BLK-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1054-M-BLK-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1054-M-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1054-M-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1054-M-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1054-M-BRN-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1054-M-BRN-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1054-M-BRN-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1054-M-BRN-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1054-M-BRN-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1055-M-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1055-M-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1055-M-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1055-M-BLK-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1055-M-BLK-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1055-M-BLK-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1055-M-BLK-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1055-M-BLK-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1055-M-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1055-M-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1055-M-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1055-M-BRN-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1055-M-BRN-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1055-M-BRN-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1055-M-BRN-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1055-M-BRN-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1056-M-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1056-M-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1056-M-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1056-M-BRN-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1056-M-BRN-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1056-M-BRN-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1056-M-BRN-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1056-M-BRN-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1057-M-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1057-M-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1057-M-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1057-M-BLK-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1057-M-BLK-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1057-M-BLK-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1057-M-BLK-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1057-M-BLK-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1057-M-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1057-M-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1057-M-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1057-M-BRN-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1057-M-BRN-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1057-M-BRN-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1057-M-BRN-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1057-M-BRN-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1058-M-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1058-M-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1058-M-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1058-M-BRN-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1058-M-BRN-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1058-M-BRN-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1058-M-BRN-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1058-M-BRN-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1059-M-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1059-M-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1059-M-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1059-M-BLK-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1059-M-BLK-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1059-M-BLK-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1059-M-BLK-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1059-M-BLK-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1059-M-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1059-M-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1059-M-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1059-M-BRN-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1059-M-BRN-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1059-M-BRN-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1059-M-BRN-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1059-M-BRN-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "106-M-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "106-M-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "106-M-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "106-M-BLK-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "106-M-BLK-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "106-M-BLK-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "106-M-BLK-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "106-M-BLK-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "106-M-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "106-M-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "106-M-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "106-M-BRN-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "106-M-BRN-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "106-M-BRN-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "106-M-BRN-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "106-M-BRN-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1061-M-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1061-M-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1061-M-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1061-M-BLK-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1061-M-BLK-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1061-M-BLK-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1061-M-BLK-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1061-M-BLK-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1061-M-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1061-M-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1061-M-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1061-M-BRN-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1061-M-BRN-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1061-M-BRN-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1061-M-BRN-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1061-M-BRN-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1062-M-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1062-M-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1062-M-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1062-M-BLK-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1062-M-BLK-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1062-M-BLK-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1062-M-BLK-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1062-M-BLK-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1062-M-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1062-M-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1062-M-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1062-M-BRN-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1062-M-BRN-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1062-M-BRN-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1062-M-BRN-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1062-M-BRN-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-M-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-M-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-M-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-M-BLK-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-M-BLK-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-M-BLK-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-M-BLK-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-M-BLK-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-M-BLKNU-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-M-BLKNU-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-M-BLKNU-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-M-BLKNU-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-M-BLKNU-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-M-BLKNU-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-M-BLKNU-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-M-BLKNU-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-M-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-M-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-M-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-M-BRN-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-M-BRN-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-M-BRN-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-M-BRN-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-M-BRN-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-M-BRNNU-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-M-BRNNU-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-M-BRNNU-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-M-BRNNU-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-M-BRNNU-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-M-BRNNU-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-M-BRNNU-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-M-BRNNU-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-M-OILBRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-M-OILBRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-M-OILBRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-M-OILBRN-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-M-OILBRN-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-M-OILBRN-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-M-OILBRN-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-M-OILBRN-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-M-TANNU-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-M-TANNU-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-M-TANNU-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-M-TANNU-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-M-TANNU-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-M-TANNU-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-M-TANNU-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-M-TANNU-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-M-WHTNU-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-M-WHTNU-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-M-WHTNU-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-M-WHTNU-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-M-WHTNU-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-M-WHTNU-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-M-WHTNU-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-M-WHTNU-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-M-YELNU-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-M-YELNU-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-M-YELNU-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-M-YELNU-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-M-YELNU-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-M-YELNU-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-M-YELNU-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-M-YELNU-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-W-BLKNU-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-W-BLKNU-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-W-BLKNU-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-W-BLKNU-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-W-BLKNU-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-W-BLKNU-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-W-BLKNU-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-W-BRNMG-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-W-BRNMG-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-W-BRNMG-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-W-BRNMG-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-W-BRNMG-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-W-BRNMG-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-W-BRNMG-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-W-BRNNU-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-W-BRNNU-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-W-BRNNU-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-W-BRNNU-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-W-BRNNU-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-W-BRNNU-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-W-BRNNU-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-W-TANNU-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-W-TANNU-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-W-TANNU-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-W-TANNU-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-W-TANNU-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-W-TANNU-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-W-TANNU-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-W-WHTNU-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-W-WHTNU-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-W-WHTNU-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-W-WHTNU-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-W-WHTNU-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-W-WHTNU-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-W-WHTNU-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-W-YELNU-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-W-YELNU-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-W-YELNU-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-W-YELNU-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-W-YELNU-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-W-YELNU-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1063-W-YELNU-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1070-W-BRN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1070-W-BRN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1070-W-BRN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1070-W-BRN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1070-W-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1070-W-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1070-W-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1070-W-BRNMG-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1070-W-BRNMG-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1070-W-BRNMG-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1070-W-BRNMG-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1070-W-BRNMG-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1070-W-BRNMG-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1070-W-BRNMG-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1070-W-BRNNU-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1070-W-BRNNU-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1070-W-BRNNU-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1070-W-BRNNU-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1070-W-BRNNU-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1070-W-BRNNU-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1070-W-BRNNU-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1070-W-TAN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1070-W-TAN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1070-W-TAN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1070-W-TAN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1070-W-TAN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1070-W-TAN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1070-W-TAN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1070-W-TANNU-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1070-W-TANNU-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1070-W-TANNU-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1070-W-TANNU-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1070-W-TANNU-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1070-W-TANNU-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1070-W-TANNU-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1070-W-WHTNU-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1070-W-WHTNU-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1070-W-WHTNU-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1070-W-WHTNU-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1070-W-WHTNU-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1070-W-WHTNU-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1070-W-WHTNU-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1070-W-YELNU-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1070-W-YELNU-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1070-W-YELNU-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1070-W-YELNU-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1070-W-YELNU-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1070-W-YELNU-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1070-W-YELNU-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1071-W-BRN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1071-W-BRN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1071-W-BRN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1071-W-BRN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1071-W-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1071-W-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1071-W-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1071-W-OLV-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1071-W-OLV-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1071-W-OLV-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1071-W-OLV-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1071-W-OLV-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1071-W-OLV-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1071-W-OLV-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1072-W-BLK-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1072-W-BLK-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1072-W-BLK-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1072-W-BLK-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1072-W-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1072-W-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1072-W-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1072-W-BRN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1072-W-BRN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1072-W-BRN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1072-W-BRN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1072-W-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1072-W-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1072-W-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1072-W-TAN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1072-W-TAN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1072-W-TAN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1072-W-TAN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1072-W-TAN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1072-W-TAN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1072-W-TAN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1074-W-BLK-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1074-W-BLK-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1074-W-BLK-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1074-W-BLK-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1074-W-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1074-W-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1074-W-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1074-W-BRN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1074-W-BRN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1074-W-BRN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1074-W-BRN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1074-W-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1074-W-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1074-W-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1075-W-BRN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1075-W-BRN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1075-W-BRN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1075-W-BRN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1075-W-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1075-W-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1075-W-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1078-M-BLKNU-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1078-M-BLKNU-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1078-M-BLKNU-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1078-M-BLKNU-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1078-M-BLKNU-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1078-M-BLKNU-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1078-M-BLKNU-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1078-M-BLKNU-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1078-M-BRNNU-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1078-M-BRNNU-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1078-M-BRNNU-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1078-M-BRNNU-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1078-M-BRNNU-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1078-M-BRNNU-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1078-M-BRNNU-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1078-M-BRNNU-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1078-M-OILBRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1078-M-OILBRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1078-M-OILBRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1078-M-OILBRN-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1078-M-OILBRN-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1078-M-OILBRN-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1078-M-OILBRN-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1078-M-OILBRN-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1079-M-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1079-M-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1079-M-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1079-M-BLK-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1079-M-BLK-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1079-M-BLK-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1079-M-BLK-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1079-M-BLK-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1079-M-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1079-M-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1079-M-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1079-M-BRN-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1079-M-BRN-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1079-M-BRN-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1079-M-BRN-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1079-M-BRN-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "108-M-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "108-M-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "108-M-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "108-M-BLK-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "108-M-BLK-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "108-M-BLK-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "108-M-BLK-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "108-M-BLK-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "108-M-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "108-M-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "108-M-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "108-M-BRN-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "108-M-BRN-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "108-M-BRN-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "108-M-BRN-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "108-M-BRN-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1080-M-OILBRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1080-M-OILBRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1080-M-OILBRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1080-M-OILBRN-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1080-M-OILBRN-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1080-M-OILBRN-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1080-M-OILBRN-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1080-M-OILBRN-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1080-W-BLK-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1080-W-BLK-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1080-W-BLK-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1080-W-BLK-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1080-W-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1080-W-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1080-W-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1080-W-BRNNU-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1080-W-BRNNU-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1080-W-BRNNU-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1080-W-BRNNU-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1080-W-BRNNU-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1080-W-BRNNU-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1080-W-BRNNU-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1080-W-OILBRN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1080-W-OILBRN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1080-W-OILBRN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1080-W-OILBRN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1080-W-OILBRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1080-W-OILBRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1080-W-OILBRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1080-W-TANNU-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1080-W-TANNU-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1080-W-TANNU-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1080-W-TANNU-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1080-W-TANNU-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1080-W-TANNU-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1080-W-TANNU-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1081-M-BLKNU-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1081-M-BLKNU-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1081-M-BLKNU-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1081-M-BLKNU-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1081-M-BLKNU-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1081-M-BLKNU-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1081-M-BLKNU-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1081-M-BLKNU-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1081-M-BRNNU-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1081-M-BRNNU-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1081-M-BRNNU-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1081-M-BRNNU-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1081-M-BRNNU-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1081-M-BRNNU-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1081-M-BRNNU-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1081-M-BRNNU-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1081-M-OILBRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1081-M-OILBRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1081-M-OILBRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1081-M-OILBRN-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1081-M-OILBRN-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1081-M-OILBRN-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1081-M-OILBRN-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1081-M-OILBRN-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1081-M-TANNU-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1081-M-TANNU-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1081-M-TANNU-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1081-M-TANNU-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1081-M-TANNU-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1081-M-TANNU-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1081-M-TANNU-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1081-M-TANNU-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1082-M-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1082-M-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1082-M-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1082-M-BLK-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1082-M-BLK-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1082-M-BLK-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1082-M-BLK-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1082-M-BLK-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1082-M-BRNNU-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1082-M-BRNNU-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1082-M-BRNNU-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1082-M-BRNNU-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1082-M-BRNNU-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1082-M-BRNNU-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1082-M-BRNNU-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1082-M-BRNNU-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1082-M-OILBRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1082-M-OILBRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1082-M-OILBRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1082-M-OILBRN-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1082-M-OILBRN-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1082-M-OILBRN-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1082-M-OILBRN-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1082-M-OILBRN-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1083-M-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1083-M-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1083-M-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1083-M-BLK-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1083-M-BLK-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1083-M-BLK-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1083-M-BLK-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1083-M-BLK-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1083-M-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1083-M-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1083-M-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1083-M-BRN-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1083-M-BRN-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1083-M-BRN-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1083-M-BRN-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1083-M-BRN-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1083-M-TAN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1083-M-TAN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1083-M-TAN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1083-M-TAN-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1083-M-TAN-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1083-M-TAN-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1083-M-TAN-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1083-M-TAN-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1086-W-BLK-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1086-W-BLK-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1086-W-BLK-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1086-W-BLK-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1086-W-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1086-W-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1086-W-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1086-W-BRN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1086-W-BRN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1086-W-BRN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1086-W-BRN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1086-W-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1086-W-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1086-W-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1086-W-BRNNU-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1086-W-BRNNU-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1086-W-BRNNU-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1086-W-BRNNU-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1086-W-BRNNU-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1086-W-BRNNU-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1086-W-BRNNU-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1086-W-TAN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1086-W-TAN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1086-W-TAN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1086-W-TAN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1086-W-TAN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1086-W-TAN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1086-W-TAN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1086-W-WHTNU-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1086-W-WHTNU-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1086-W-WHTNU-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1086-W-WHTNU-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1086-W-WHTNU-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1086-W-WHTNU-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1086-W-WHTNU-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1087-W-BLK-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1087-W-BLK-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1087-W-BLK-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1087-W-BLK-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1087-W-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1087-W-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1087-W-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1087-W-BRN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1087-W-BRN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1087-W-BRN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1087-W-BRN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1087-W-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1087-W-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1087-W-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1087-W-BRNNU-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1087-W-BRNNU-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1087-W-BRNNU-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1087-W-BRNNU-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1087-W-BRNNU-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1087-W-BRNNU-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1087-W-BRNNU-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1087-W-TAN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1087-W-TAN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1087-W-TAN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1087-W-TAN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1087-W-TAN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1087-W-TAN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1087-W-TAN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1087-W-WHTNU-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1087-W-WHTNU-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1087-W-WHTNU-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1087-W-WHTNU-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1087-W-WHTNU-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1087-W-WHTNU-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1087-W-WHTNU-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1088-W-BLK-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1088-W-BLK-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1088-W-BLK-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1088-W-BLK-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1088-W-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1088-W-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1088-W-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1088-W-BRN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1088-W-BRN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1088-W-BRN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1088-W-BRN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1088-W-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1088-W-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1088-W-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1088-W-BRNNU-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1088-W-BRNNU-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1088-W-BRNNU-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1088-W-BRNNU-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1088-W-BRNNU-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1088-W-BRNNU-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1088-W-BRNNU-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1088-W-TAN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1088-W-TAN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1088-W-TAN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1088-W-TAN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1088-W-TAN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1088-W-TAN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1088-W-TAN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1088-W-WHTNU-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1088-W-WHTNU-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1088-W-WHTNU-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1088-W-WHTNU-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1088-W-WHTNU-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1088-W-WHTNU-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1088-W-WHTNU-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "108D-M-BLK-40": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "108D-M-BLK-41": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "108D-M-BLK-42": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "108D-M-BLK-43": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "108D-M-BLK-44": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "108D-M-BLK-45": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "108D-M-BLK-46": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "108D-M-BLK-47": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "108D-M-BRN-40": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "108D-M-BRN-41": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "108D-M-BRN-42": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "108D-M-BRN-43": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "108D-M-BRN-44": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "108D-M-BRN-45": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "108D-M-BRN-46": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "108D-M-BRN-47": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "108V-M-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "108V-M-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "108V-M-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "108V-M-BLK-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "108V-M-BLK-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "108V-M-BLK-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "108V-M-BLK-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "108V-M-BLK-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "108V-M-BLUE-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "108V-M-BLUE-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "108V-M-BLUE-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "108V-M-BLUE-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "108V-M-BLUE-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "108V-M-BLUE-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "108V-M-BLUE-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "108V-M-BLUE-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "108V-M-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "108V-M-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "108V-M-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "108V-M-BRN-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "108V-M-BRN-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "108V-M-BRN-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "108V-M-BRN-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "108V-M-BRN-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "109-M-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "109-M-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "109-M-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "109-M-BLK-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "109-M-BLK-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "109-M-BLK-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "109-M-BLK-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "109-M-BLK-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "109-M-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "109-M-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "109-M-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "109-M-BRN-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "109-M-BRN-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "109-M-BRN-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "109-M-BRN-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "109-M-BRN-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "109-M-HNY-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "109-M-HNY-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "109-M-HNY-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "109-M-HNY-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "109-M-HNY-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "109-M-HNY-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "109-M-HNY-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "109-M-HNY-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "109-M-WHT-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "109-M-WHT-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "109-M-WHT-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "109-M-WHT-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "109-M-WHT-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "109-M-WHT-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "109-M-WHT-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "109-M-WHT-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "13-M2-BLKWH-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "13-M2-BLKWH-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "13-M2-BLKWH-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "13-M2-BLKWH-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "13-M2-BLKWH-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "13-M2-BLKWH-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "13-M2-BLKWH-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "13-M2-BLKWH-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "13-W-BLKWH-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "13-W-BLKWH-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "13-W-BLKWH-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "13-W-BLKWH-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "13-W-BLKWH-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "13-W-BLKWH-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "13-W-BLKWH-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "13-W-BRN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "13-W-BRN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "13-W-BRN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "13-W-BRN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "13-W-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "13-W-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "13-W-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-M-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-M-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-M-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-M-BLK-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-M-BLK-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-M-BLK-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-M-BLK-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-M-BLK-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-M-BLUE-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-M-BLUE-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-M-BLUE-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-M-BLUE-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-M-BLUE-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-M-BLUE-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-M-BLUE-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-M-BLUE-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-M-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-M-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-M-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-M-BRN-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-M-BRN-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-M-BRN-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-M-BRN-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-M-BRN-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-M-TAN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-M-TAN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-M-TAN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-M-TAN-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-M-TAN-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-M-TAN-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-M-TAN-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-M-TAN-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-M-WHT-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-M-WHT-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-M-WHT-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-M-WHT-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-M-WHT-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-M-WHT-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-M-WHT-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-M-WHT-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-W-BLK-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-W-BLK-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-W-BLK-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-W-BLK-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-W-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-W-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-W-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-W-BLUE-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-W-BLUE-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-W-BLUE-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-W-BLUE-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-W-BLUE-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-W-BLUE-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-W-BLUE-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-W-BRN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-W-BRN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-W-BRN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-W-BRN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-W-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-W-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-W-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-W-GRN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-W-GRN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-W-GRN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-W-GRN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-W-GRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-W-GRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-W-GRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-W-GRY-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-W-GRY-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-W-GRY-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-W-GRY-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-W-GRY-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-W-GRY-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-W-GRY-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-W-ORG-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-W-ORG-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-W-ORG-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-W-ORG-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-W-ORG-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-W-ORG-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-W-ORG-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-W-RED-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-W-RED-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-W-RED-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-W-RED-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-W-RED-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-W-RED-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-W-RED-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-W-TAN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-W-TAN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-W-TAN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-W-TAN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-W-TAN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-W-TAN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-W-TAN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-W-WHT-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-W-WHT-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-W-WHT-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-W-WHT-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-W-WHT-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-W-WHT-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15-W-WHT-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1500-W-BLKSU-36": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1500-W-BLKSU-37": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1500-W-BLKSU-38": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1500-W-BLKSU-39": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1500-W-BLKSU-40": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1500-W-BLKSU-41": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1500-W-BLKSU-42": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1500-W-TAN-36": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1500-W-TAN-37": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1500-W-TAN-38": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1500-W-TAN-39": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1500-W-TAN-40": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1500-W-TAN-41": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "1500-W-TAN-42": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "15V-M-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15V-M-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15V-M-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15V-M-BLK-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15V-M-BLK-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15V-M-BLK-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15V-M-BLK-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15V-M-BLK-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15V-M-BLUE-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15V-M-BLUE-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15V-M-BLUE-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15V-M-BLUE-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15V-M-BLUE-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15V-M-BLUE-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15V-M-BLUE-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15V-M-BLUE-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15V-M-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15V-M-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15V-M-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15V-M-BRN-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15V-M-BRN-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15V-M-BRN-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15V-M-BRN-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15V-M-BRN-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15V-W-BLK-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15V-W-BLK-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15V-W-BLK-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15V-W-BLK-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15V-W-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15V-W-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15V-W-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15V-W-BLUE-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15V-W-BLUE-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15V-W-BLUE-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15V-W-BLUE-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15V-W-BLUE-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15V-W-BLUE-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15V-W-BLUE-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15V-W-BRN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15V-W-BRN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15V-W-BRN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15V-W-BRN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15V-W-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15V-W-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "15V-W-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1V-W-BLK-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1V-W-BLK-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1V-W-BLK-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1V-W-BLK-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1V-W-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1V-W-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1V-W-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1V-W-BRN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1V-W-BRN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1V-W-BRN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1V-W-BRN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1V-W-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1V-W-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "1V-W-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "2-W-BLK-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "2-W-BLK-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "2-W-BLK-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "2-W-BLK-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "2-W-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "2-W-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "2-W-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "2-W-BRN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "2-W-BRN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "2-W-BRN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "2-W-BRN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "2-W-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "2-W-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "2-W-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "2-W-RED-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "2-W-RED-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "2-W-RED-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "2-W-RED-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "2-W-RED-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "2-W-RED-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "2-W-RED-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "2-W-TAN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "2-W-TAN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "2-W-TAN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "2-W-TAN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "2-W-TAN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "2-W-TAN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "2-W-TAN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "20-M-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "20-M-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "20-M-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "20-M-BLK-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "20-M-BLK-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "20-M-BLK-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "20-M-BLK-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "20-M-BLK-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "20-M-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "20-M-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "20-M-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "20-M-BRN-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "20-M-BRN-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "20-M-BRN-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "20-M-BRN-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "20-M-BRN-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "202-W-BRN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "202-W-BRN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "202-W-BRN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "202-W-BRN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "202-W-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "202-W-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "202-W-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "202-W-HNY-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "202-W-HNY-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "202-W-HNY-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "202-W-HNY-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "202-W-HNY-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "202-W-HNY-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "202-W-HNY-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "21-M-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "21-M-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "21-M-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "21-M-BLK-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "21-M-BLK-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "21-M-BLK-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "21-M-BLK-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "21-M-BLK-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "21-M-BLUE-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "21-M-BLUE-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "21-M-BLUE-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "21-M-BLUE-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "21-M-BLUE-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "21-M-BLUE-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "21-M-BLUE-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "21-M-BLUE-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "21-M-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "21-M-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "21-M-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "21-M-BRN-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "21-M-BRN-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "21-M-BRN-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "21-M-BRN-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "21-M-BRN-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "21-M-WHT-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "21-M-WHT-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "21-M-WHT-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "21-M-WHT-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "21-M-WHT-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "21-M-WHT-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "21-M-WHT-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "21-M-WHT-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "21V-M-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "21V-M-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "21V-M-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "21V-M-BLK-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "21V-M-BLK-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "21V-M-BLK-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "21V-M-BLK-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "21V-M-BLK-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "21V-M-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "21V-M-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "21V-M-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "21V-M-BRN-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "21V-M-BRN-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "21V-M-BRN-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "21V-M-BRN-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "21V-M-BRN-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "22-M-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "22-M-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "22-M-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "22-M-BLK-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "22-M-BLK-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "22-M-BLK-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "22-M-BLK-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "22-M-BLK-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "22-M-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "22-M-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "22-M-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "22-M-BRN-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "22-M-BRN-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "22-M-BRN-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "22-M-BRN-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "22-M-BRN-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "24-M-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "24-M-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "24-M-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "24-M-BLK-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "24-M-BLK-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "24-M-BLK-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "24-M-BLK-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "24-M-BLK-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "24-M-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "24-M-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "24-M-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "24-M-BRN-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "24-M-BRN-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "24-M-BRN-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "24-M-BRN-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "24-M-BRN-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "24-M-TAN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "24-M-TAN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "24-M-TAN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "24-M-TAN-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "24-M-TAN-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "24-M-TAN-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "24-M-TAN-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "24-M-TAN-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "24-W-BLK-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "24-W-BLK-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "24-W-BLK-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "24-W-BLK-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "24-W-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "24-W-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "24-W-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "24-W-BLUE-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "24-W-BLUE-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "24-W-BLUE-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "24-W-BLUE-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "24-W-BLUE-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "24-W-BLUE-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "24-W-BLUE-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "24-W-BRN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "24-W-BRN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "24-W-BRN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "24-W-BRN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "24-W-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "24-W-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "24-W-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "24-W-GRY-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "24-W-GRY-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "24-W-GRY-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "24-W-GRY-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "24-W-GRY-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "24-W-GRY-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "24-W-GRY-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "24-W-RED-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "24-W-RED-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "24-W-RED-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "24-W-RED-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "24-W-RED-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "24-W-RED-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "24-W-RED-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "24-W-TAN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "24-W-TAN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "24-W-TAN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "24-W-TAN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "24-W-TAN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "24-W-TAN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "24-W-TAN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "24-W-VIO-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "24-W-VIO-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "24-W-VIO-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "24-W-VIO-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "24-W-VIO-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "24-W-VIO-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "24-W-VIO-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "27-W-BLK-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "27-W-BLK-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "27-W-BLK-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "27-W-BLK-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "27-W-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "27-W-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "27-W-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "27-W-BRN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "27-W-BRN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "27-W-BRN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "27-W-BRN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "27-W-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "27-W-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "27-W-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "27-W-HNY-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "27-W-HNY-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "27-W-HNY-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "27-W-HNY-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "27-W-HNY-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "27-W-HNY-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "27-W-HNY-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "27-W-PNK-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "27-W-PNK-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "27-W-PNK-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "27-W-PNK-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "27-W-PNK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "27-W-PNK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "27-W-PNK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "27-W-TAN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "27-W-TAN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "27-W-TAN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "27-W-TAN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "27-W-TAN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "27-W-TAN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "27-W-TAN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "27V-W-BLK-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "27V-W-BLK-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "27V-W-BLK-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "27V-W-BLK-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "27V-W-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "27V-W-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "27V-W-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "27V-W-BRN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "27V-W-BRN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "27V-W-BRN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "27V-W-BRN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "27V-W-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "27V-W-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "27V-W-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "28-W-BLK-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "28-W-BLK-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "28-W-BLK-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "28-W-BLK-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "28-W-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "28-W-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "28-W-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "28-W-BRN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "28-W-BRN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "28-W-BRN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "28-W-BRN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "28-W-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "28-W-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "28-W-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "28-W-GRY-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "28-W-GRY-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "28-W-GRY-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "28-W-GRY-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "28-W-GRY-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "28-W-GRY-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "28-W-GRY-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "28-W-HNY-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "28-W-HNY-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "28-W-HNY-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "28-W-HNY-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "28-W-HNY-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "28-W-HNY-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "28-W-HNY-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "28-W-TAN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "28-W-TAN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "28-W-TAN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "28-W-TAN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "28-W-TAN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "28-W-TAN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "28-W-TAN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "28-W-VIO-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "28-W-VIO-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "28-W-VIO-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "28-W-VIO-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "28-W-VIO-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "28-W-VIO-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "28-W-VIO-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "28-W-WHT-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "28-W-WHT-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "28-W-WHT-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "28-W-WHT-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "28-W-WHT-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "28-W-WHT-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "28-W-WHT-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "28V-W-BLK-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "28V-W-BLK-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "28V-W-BLK-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "28V-W-BLK-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "28V-W-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "28V-W-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "28V-W-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "28V-W-BRN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "28V-W-BRN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "28V-W-BRN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "28V-W-BRN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "28V-W-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "28V-W-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "28V-W-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "30-W-BLK-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "30-W-BLK-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "30-W-BLK-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "30-W-BLK-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "30-W-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "30-W-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "30-W-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "30-W-BRN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "30-W-BRN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "30-W-BRN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "30-W-BRN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "30-W-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "30-W-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "30-W-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "30-W-GRN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "30-W-GRN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "30-W-GRN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "30-W-GRN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "30-W-GRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "30-W-GRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "30-W-GRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "30-W-ORG-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "30-W-ORG-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "30-W-ORG-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "30-W-ORG-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "30-W-ORG-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "30-W-ORG-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "30-W-ORG-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "30-W-TAN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "30-W-TAN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "30-W-TAN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "30-W-TAN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "30-W-TAN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "30-W-TAN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "30-W-TAN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "3001-W-BLK-36": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "3001-W-BLK-37": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "3001-W-BLK-38": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "3001-W-BLK-39": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "3001-W-BLK-40": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "3001-W-BLK-41": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "3002-W-BLK-36": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "3002-W-BLK-37": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "3002-W-BLK-38": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "3002-W-BLK-39": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "3002-W-BLK-40": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "3002-W-BLK-41": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "3002-W-BLK-42": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "3002-W-BRN-36": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "3002-W-BRN-37": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "3002-W-BRN-38": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "3002-W-BRN-39": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "3002-W-BRN-40": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "3002-W-BRN-41": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "3002-W-BRN-42": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "3002-W-HNY-36": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "3002-W-HNY-37": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "3002-W-HNY-38": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "3002-W-HNY-39": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "3002-W-HNY-40": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "3002-W-HNY-41": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "3002-W-HNY-42": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "3002-W-NTRL-36": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "3002-W-NTRL-37": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "3002-W-NTRL-38": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "3002-W-NTRL-39": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "3002-W-NTRL-40": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "3002-W-NTRL-41": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "3002-W-NTRL-42": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "3003-M-BLK-40": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "3003-M-BLK-41": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "3003-M-BLK-42": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "3003-M-BLK-43": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "3003-M-BLK-44": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "3003-M-BLK-45": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "3003-M-BLK-46": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "3003-M-BLKNU-40": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "3003-M-BLKNU-41": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "3003-M-BLKNU-42": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "3003-M-BLKNU-43": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "3003-M-BLKNU-44": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "3003-M-BLKNU-45": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "3003-M-BLKNU-46": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "3003-M-BRNNU-40": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "3003-M-BRNNU-41": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "3003-M-BRNNU-42": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "3003-M-BRNNU-43": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "3003-M-BRNNU-44": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "3003-M-BRNNU-45": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "3003-M-BRNNU-46": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "3003-M-GRNNU-40": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "3003-M-GRNNU-41": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "3003-M-GRNNU-42": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "3003-M-GRNNU-43": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "3003-M-GRNNU-44": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "3003-M-GRNNU-45": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "3003-M-GRNNU-46": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "3003-M-GRNNU-47": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "3003-M-HNY-40": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "3003-M-HNY-41": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "3003-M-HNY-42": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "3003-M-HNY-43": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "3003-M-HNY-44": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "3003-M-HNY-45": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "3003-M-HNY-46": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "3003-M-TANNU-40": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "3003-M-TANNU-41": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "3003-M-TANNU-42": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "3003-M-TANNU-43": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "3003-M-TANNU-44": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "3003-M-TANNU-45": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "3003-M-TANNU-46": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "3003-W-BLK-36": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "3003-W-BLK-37": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "3003-W-BLK-38": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "3003-W-BLK-39": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "3003-W-BLKNU-36": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "3003-W-BLKNU-37": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "3003-W-BLKNU-38": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "3003-W-BLKNU-39": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "3003-W-BRNNU-36": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "3003-W-BRNNU-37": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "3003-W-BRNNU-38": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "3003-W-BRNNU-39": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "3003-W-GRNNU-36": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "3003-W-GRNNU-37": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "3003-W-GRNNU-38": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "3003-W-GRNNU-39": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "3003-W-HNY-36": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "3003-W-HNY-37": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "3003-W-HNY-38": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "3003-W-HNY-39": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "3003-W-TANNU-36": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "3003-W-TANNU-37": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "3003-W-TANNU-38": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "3003-W-TANNU-39": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "4-M-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "4-M-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "4-M-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "4-M-BLK-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "4-M-BLK-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "4-M-BLK-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "4-M-BLK-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "4-M-BLK-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "4-M-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "4-M-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "4-M-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "4-M-BRN-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "4-M-BRN-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "4-M-BRN-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "4-M-BRN-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "4-M-BRN-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "4-M-HNY-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "4-M-HNY-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "4-M-HNY-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "4-M-HNY-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "4-M-HNY-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "4-M-HNY-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "4-M-HNY-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "4-M-HNY-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "4-M-TAN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "4-M-TAN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "4-M-TAN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "4-M-TAN-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "4-M-TAN-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "4-M-TAN-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "4-M-TAN-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "4-M-TAN-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "41-W-BRN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "41-W-BRN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "41-W-BRN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "41-W-BRN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "41-W-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "41-W-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "41-W-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "41-W-HNY-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "41-W-HNY-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "41-W-HNY-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "41-W-HNY-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "41-W-HNY-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "41-W-HNY-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "41-W-HNY-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "43-W-BRN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "43-W-BRN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "43-W-BRN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "43-W-BRN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "43-W-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "43-W-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "43-W-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "43-W-RED-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "43-W-RED-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "43-W-RED-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "43-W-RED-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "43-W-RED-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "43-W-RED-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "43-W-RED-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "45-W-BRN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "45-W-BRN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "45-W-BRN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "45-W-BRN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "45-W-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "45-W-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "45-W-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "45-W-TAN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "45-W-TAN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "45-W-TAN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "45-W-TAN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "45-W-TAN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "45-W-TAN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "45-W-TAN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "5-M-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "5-M-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "5-M-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "5-M-BLK-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "5-M-BLK-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "5-M-BLK-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "5-M-BLK-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "5-M-BLK-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "5-W-BLK-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "5-W-BLK-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "5-W-BLK-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "5-W-BLK-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "5-W-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "5-W-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "5-W-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "5-W-BRN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "5-W-BRN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "5-W-BRN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "5-W-BRN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "5-W-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "5-W-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "5-W-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "5-W-RED-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "5-W-RED-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "5-W-RED-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "5-W-RED-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "5-W-RED-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "5-W-RED-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "5-W-RED-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "5-W-TAN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "5-W-TAN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "5-W-TAN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "5-W-TAN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "5-W-TAN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "5-W-TAN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "5-W-TAN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "5-W-VIO-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "5-W-VIO-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "5-W-VIO-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "5-W-VIO-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "5-W-VIO-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "5-W-VIO-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "5-W-VIO-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "5-W-WHT-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "5-W-WHT-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "5-W-WHT-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "5-W-WHT-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "5-W-WHT-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "5-W-WHT-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "5-W-WHT-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "500-W-BLK-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "500-W-BLK-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "500-W-BLK-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "500-W-BLK-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "500-W-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "500-W-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "500-W-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "500-W-BRN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "500-W-BRN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "500-W-BRN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "500-W-BRN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "500-W-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "500-W-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "500-W-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "501-M-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "501-M-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "501-M-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "501-M-BLK-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "501-M-BLK-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "501-M-BLK-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "501-M-BLK-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "501-M-BLK-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "501-M-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "501-M-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "501-M-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "501-M-BRN-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "501-M-BRN-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "501-M-BRN-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "501-M-BRN-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "501-M-BRN-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "501-M-HNY-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "501-M-HNY-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "501-M-HNY-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "501-M-HNY-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "501-M-HNY-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "501-M-HNY-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "501-M-HNY-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "501-M-HNY-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "501-W-BLK-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "501-W-BLK-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "501-W-BLK-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "501-W-BLK-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "501-W-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "501-W-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "501-W-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "501-W-BRN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "501-W-BRN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "501-W-BRN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "501-W-BRN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "501-W-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "501-W-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "501-W-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "501-W-HNY-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "501-W-HNY-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "501-W-HNY-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "501-W-HNY-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "501-W-HNY-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "501-W-HNY-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "501-W-HNY-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "504-M-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "504-M-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "504-M-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "504-M-BLK-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "504-M-BLK-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "504-M-BLK-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "504-M-BLK-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "504-M-BLK-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "504-M-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "504-M-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "504-M-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "504-M-BRN-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "504-M-BRN-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "504-M-BRN-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "504-M-BRN-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "504-M-BRN-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "504-M-WHT-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "504-M-WHT-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "504-M-WHT-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "504-M-WHT-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "504-M-WHT-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "504-M-WHT-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "504-M-WHT-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "504-M-WHT-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "505-W-BLK-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "505-W-BLK-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "505-W-BLK-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "505-W-BLK-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "505-W-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "505-W-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "505-W-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "506-W-BLK-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "506-W-BLK-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "506-W-BLK-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "506-W-BLK-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "506-W-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "506-W-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "506-W-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "506-W-BRN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "506-W-BRN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "506-W-BRN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "506-W-BRN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "506-W-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "506-W-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "506-W-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "506B-W-BLK-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "506B-W-BLK-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "506B-W-BLK-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "506B-W-BLK-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "506B-W-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "506B-W-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "506B-W-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "506B-W-BRN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "506B-W-BRN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "506B-W-BRN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "506B-W-BRN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "506B-W-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "506B-W-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "506B-W-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "506B-W-TAN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "506B-W-TAN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "506B-W-TAN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "506B-W-TAN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "506B-W-TAN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "506B-W-TAN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "506B-W-TAN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "508-W-BLK-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "508-W-BLK-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "508-W-BLK-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "508-W-BLK-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "508-W-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "508-W-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "508-W-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "508-W-BRN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "508-W-BRN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "508-W-BRN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "508-W-BRN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "508-W-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "508-W-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "508-W-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "508-W-TAN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "508-W-TAN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "508-W-TAN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "508-W-TAN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "508-W-TAN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "508-W-TAN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "508-W-TAN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "509-W-BLK-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "509-W-BLK-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "509-W-BLK-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "509-W-BLK-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "509-W-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "509-W-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "509-W-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "509-W-BRN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "509-W-BRN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "509-W-BRN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "509-W-BRN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "509-W-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "509-W-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "509-W-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "509-W-TAN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "509-W-TAN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "509-W-TAN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "509-W-TAN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "509-W-TAN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "509-W-TAN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "509-W-TAN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "510-M-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "510-M-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "510-M-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "510-M-BLK-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "510-M-BLK-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "510-M-BLK-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "510-M-BLK-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "510-M-BLK-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "510-M-BLUE-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "510-M-BLUE-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "510-M-BLUE-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "510-M-BLUE-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "510-M-BLUE-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "510-M-BLUE-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "510-M-BLUE-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "510-M-BLUE-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "510-M-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "510-M-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "510-M-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "510-M-BRN-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "510-M-BRN-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "510-M-BRN-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "510-M-BRN-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "510-M-BRN-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "510-M-GRY-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "510-M-GRY-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "510-M-GRY-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "510-M-GRY-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "510-M-GRY-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "510-M-GRY-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "510-M-GRY-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "510-M-GRY-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "510-M-WHT-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "510-M-WHT-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "510-M-WHT-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "510-M-WHT-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "510-M-WHT-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "510-M-WHT-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "510-M-WHT-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "510-M-WHT-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "510-W-BLK-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "510-W-BLK-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "510-W-BLK-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "510-W-BLK-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "510-W-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "510-W-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "510-W-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "510-W-BRN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "510-W-BRN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "510-W-BRN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "510-W-BRN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "510-W-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "510-W-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "510-W-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "510-W-TAN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "510-W-TAN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "510-W-TAN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "510-W-TAN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "510-W-TAN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "510-W-TAN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "510-W-TAN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "510V-M-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "510V-M-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "510V-M-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "510V-M-BLK-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "510V-M-BLK-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "510V-M-BLK-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "510V-M-BLK-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "510V-M-BLK-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "510V-M-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "510V-M-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "510V-M-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "510V-M-BRN-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "510V-M-BRN-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "510V-M-BRN-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "510V-M-BRN-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "510V-M-BRN-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "511-M-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "511-M-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "511-M-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "511-M-BLK-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "511-M-BLK-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "511-M-BLK-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "511-M-BLK-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "511-M-BLK-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "511-M-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "511-M-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "511-M-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "511-M-BRN-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "511-M-BRN-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "511-M-BRN-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "511-M-BRN-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "511-M-BRN-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "512-M-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "512-M-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "512-M-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "512-M-BLK-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "512-M-BLK-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "512-M-BLK-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "512-M-BLK-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "512-M-BLK-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "512-M-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "512-M-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "512-M-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "512-M-BRN-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "512-M-BRN-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "512-M-BRN-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "512-M-BRN-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "512-M-BRN-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "512-M-TAN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "512-M-TAN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "512-M-TAN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "512-M-TAN-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "512-M-TAN-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "512-M-TAN-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "512-M-TAN-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "512-M-TAN-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "513-M-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "513-M-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "513-M-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "513-M-BLK-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "513-M-BLK-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "513-M-BLK-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "513-M-BLK-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "513-M-BLK-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "513-M-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "513-M-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "513-M-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "513-M-BRN-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "513-M-BRN-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "513-M-BRN-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "513-M-BRN-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "513-M-BRN-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "514-M-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "514-M-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "514-M-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "514-M-BLK-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "514-M-BLK-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "514-M-BLK-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "514-M-BLK-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "514-M-BLK-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "514-M-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "514-M-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "514-M-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "514-M-BRN-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "514-M-BRN-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "514-M-BRN-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "514-M-BRN-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "514-M-BRN-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "517-W-BLK-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "517-W-BLK-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "517-W-BLK-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "517-W-BLK-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "517-W-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "517-W-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "517-W-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "517-W-BRN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "517-W-BRN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "517-W-BRN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "517-W-BRN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "517-W-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "517-W-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "517-W-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "517-W-TAN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "517-W-TAN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "517-W-TAN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "517-W-TAN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "517-W-TAN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "517-W-TAN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "517-W-TAN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "517V-W-BLK-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "517V-W-BLK-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "517V-W-BLK-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "517V-W-BLK-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "517V-W-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "517V-W-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "517V-W-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "517V-W-BRN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "517V-W-BRN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "517V-W-BRN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "517V-W-BRN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "517V-W-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "517V-W-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "517V-W-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "518-W-BLK-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "518-W-BLK-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "518-W-BLK-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "518-W-BLK-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "518-W-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "518-W-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "518-W-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "518-W-BRN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "518-W-BRN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "518-W-BRN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "518-W-BRN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "518-W-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "518-W-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "518-W-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "518-W-TAN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "518-W-TAN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "518-W-TAN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "518-W-TAN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "518-W-TAN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "518-W-TAN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "518-W-TAN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "519-W-BLK-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "519-W-BLK-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "519-W-BLK-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "519-W-BLK-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "519-W-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "519-W-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "519-W-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "519-W-BRN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "519-W-BRN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "519-W-BRN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "519-W-BRN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "519-W-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "519-W-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "519-W-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "519-W-HNY-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "519-W-HNY-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "519-W-HNY-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "519-W-HNY-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "519-W-HNY-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "519-W-HNY-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "519-W-HNY-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "519V-W-BLK-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "519V-W-BLK-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "519V-W-BLK-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "519V-W-BLK-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "519V-W-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "519V-W-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "519V-W-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "519V-W-BRN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "519V-W-BRN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "519V-W-BRN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "519V-W-BRN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "519V-W-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "519V-W-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "519V-W-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "520-W-BLK-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "520-W-BLK-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "520-W-BLK-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "520-W-BLK-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "520-W-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "520-W-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "520-W-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "520-W-BRN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "520-W-BRN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "520-W-BRN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "520-W-BRN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "520-W-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "520-W-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "520-W-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "520-W-TAN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "520-W-TAN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "520-W-TAN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "520-W-TAN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "520-W-TAN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "520-W-TAN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "520-W-TAN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "521-W-BLK-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "521-W-BLK-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "521-W-BLK-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "521-W-BLK-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "521-W-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "521-W-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "521-W-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "521-W-BRN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "521-W-BRN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "521-W-BRN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "521-W-BRN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "521-W-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "521-W-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "521-W-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "521-W-HNY-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "521-W-HNY-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "521-W-HNY-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "521-W-HNY-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "521-W-HNY-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "521-W-HNY-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "521-W-HNY-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "521-W-RED-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "521-W-RED-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "521-W-RED-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "521-W-RED-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "521-W-RED-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "521-W-RED-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "521-W-RED-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "521-W-TAN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "521-W-TAN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "521-W-TAN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "521-W-TAN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "521-W-TAN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "521-W-TAN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "521-W-TAN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "521-W-WHT-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "521-W-WHT-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "521-W-WHT-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "521-W-WHT-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "521-W-WHT-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "521-W-WHT-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "521-W-WHT-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "524-W-BLK-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "524-W-BLK-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "524-W-BLK-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "524-W-BLK-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "524-W-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "524-W-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "524-W-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "524-W-BRN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "524-W-BRN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "524-W-BRN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "524-W-BRN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "524-W-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "524-W-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "524-W-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "524-W-TAN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "524-W-TAN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "524-W-TAN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "524-W-TAN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "524-W-TAN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "524-W-TAN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "524-W-TAN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "5V-W-BLK-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "5V-W-BLK-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "5V-W-BLK-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "5V-W-BLK-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "5V-W-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "5V-W-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "5V-W-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "5V-W-BRN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "5V-W-BRN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "5V-W-BRN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "5V-W-BRN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "5V-W-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "5V-W-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "5V-W-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "6-M-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "6-M-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "6-M-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "6-M-BLK-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "6-M-BLK-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "6-M-BLK-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "6-M-BLK-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "6-M-BLK-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "6-M-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "6-M-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "6-M-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "6-M-BRN-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "6-M-BRN-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "6-M-BRN-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "6-M-BRN-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "6-M-BRN-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "6-M-GRY-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "6-M-GRY-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "6-M-GRY-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "6-M-GRY-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "6-M-GRY-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "6-M-GRY-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "6-M-GRY-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "6-M-GRY-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "6-M-TAN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "6-M-TAN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "6-M-TAN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "6-M-TAN-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "6-M-TAN-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "6-M-TAN-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "6-M-TAN-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "6-M-TAN-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "6-W-BLK-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "6-W-BLK-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "6-W-BLK-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "6-W-BLK-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "6-W-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "6-W-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "6-W-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "6-W-BLUE-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "6-W-BLUE-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "6-W-BLUE-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "6-W-BLUE-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "6-W-BLUE-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "6-W-BLUE-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "6-W-BLUE-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "6-W-BRN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "6-W-BRN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "6-W-BRN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "6-W-BRN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "6-W-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "6-W-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "6-W-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "6-W-HNY-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "6-W-HNY-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "6-W-HNY-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "6-W-HNY-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "6-W-HNY-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "6-W-HNY-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "6-W-HNY-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "6-W-ORG-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "6-W-ORG-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "6-W-ORG-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "6-W-ORG-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "6-W-ORG-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "6-W-ORG-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "6-W-ORG-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "6-W-RED-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "6-W-RED-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "6-W-RED-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "6-W-RED-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "6-W-RED-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "6-W-RED-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "6-W-RED-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "6-W-TAN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "6-W-TAN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "6-W-TAN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "6-W-TAN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "6-W-TAN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "6-W-TAN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "6-W-TAN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "6-W-WHT-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "6-W-WHT-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "6-W-WHT-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "6-W-WHT-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "6-W-WHT-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "6-W-WHT-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "6-W-WHT-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "63-W-BLK-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "63-W-BLK-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "63-W-BLK-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "63-W-BLK-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "63-W-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "63-W-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "63-W-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-M-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-M-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-M-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-M-BLK-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-M-BLK-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-M-BLK-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-M-BLK-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-M-BLK-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-M-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-M-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-M-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-M-BRN-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-M-BRN-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-M-BRN-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-M-BRN-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-M-BRN-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-M-GRY-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-M-GRY-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-M-GRY-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-M-GRY-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-M-GRY-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-M-GRY-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-M-GRY-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-M-GRY-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-M-TAN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-M-TAN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-M-TAN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-M-TAN-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-M-TAN-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-M-TAN-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-M-TAN-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-M-TAN-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-M-WHT-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-M-WHT-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-M-WHT-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-M-WHT-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-M-WHT-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-M-WHT-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-M-WHT-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-M-WHT-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-W-BLK-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-W-BLK-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-W-BLK-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-W-BLK-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-W-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-W-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-W-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-W-BLUE-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-W-BLUE-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-W-BLUE-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-W-BLUE-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-W-BLUE-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-W-BLUE-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-W-BLUE-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-W-BRN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-W-BRN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-W-BRN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-W-BRN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-W-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-W-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-W-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-W-GRN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-W-GRN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-W-GRN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-W-GRN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-W-GRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-W-GRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-W-GRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-W-GRY-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-W-GRY-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-W-GRY-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-W-GRY-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-W-GRY-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-W-GRY-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-W-GRY-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-W-HNY-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-W-HNY-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-W-HNY-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-W-HNY-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-W-HNY-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-W-HNY-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-W-HNY-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-W-ORG-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-W-ORG-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-W-ORG-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-W-ORG-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-W-ORG-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-W-ORG-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-W-ORG-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-W-TAN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-W-TAN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-W-TAN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-W-TAN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-W-TAN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-W-TAN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-W-TAN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-W-VIO-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-W-VIO-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-W-VIO-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-W-VIO-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-W-VIO-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-W-VIO-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-W-VIO-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-W-WHT-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-W-WHT-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-W-WHT-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-W-WHT-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-W-WHT-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-W-WHT-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "77-W-WHT-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "78-M-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "78-M-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "78-M-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "78-M-BLK-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "78-M-BLK-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "78-M-BLK-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "78-M-BLK-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "78-M-BLK-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "78-M-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "78-M-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "78-M-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "78-M-BRN-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "78-M-BRN-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "78-M-BRN-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "78-M-BRN-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "78-M-BRN-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "79-M-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "79-M-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "79-M-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "79-M-BLK-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "79-M-BLK-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "79-M-BLK-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "79-M-BLK-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "79-M-BLK-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "79-M-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "79-M-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "79-M-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "79-M-BRN-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "79-M-BRN-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "79-M-BRN-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "79-M-BRN-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "79-M-BRN-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "79-M-HNY-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "79-M-HNY-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "79-M-HNY-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "79-M-HNY-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "79-M-HNY-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "79-M-HNY-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "79-M-HNY-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "79-M-HNY-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-M-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-M-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-M-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-M-BLK-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-M-BLK-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-M-BLK-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-M-BLK-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-M-BLK-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-M-BLUE-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-M-BLUE-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-M-BLUE-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-M-BLUE-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-M-BLUE-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-M-BLUE-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-M-BLUE-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-M-BLUE-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-M-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-M-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-M-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-M-BRN-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-M-BRN-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-M-BRN-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-M-BRN-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-M-BRN-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-M-GRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-M-GRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-M-GRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-M-GRN-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-M-GRN-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-M-GRN-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-M-GRN-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-M-GRN-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-M-GRY-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-M-GRY-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-M-GRY-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-M-GRY-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-M-GRY-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-M-GRY-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-M-GRY-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-M-GRY-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-M-HNY-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-M-HNY-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-M-HNY-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-M-HNY-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-M-HNY-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-M-HNY-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-M-HNY-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-M-HNY-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-M-RED-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-M-RED-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-M-RED-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-M-RED-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-M-RED-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-M-RED-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-M-RED-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-M-RED-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-M-TAN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-M-TAN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-M-TAN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-M-TAN-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-M-TAN-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-M-TAN-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-M-TAN-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-M-TAN-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-M-WHT-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-M-WHT-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-M-WHT-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-M-WHT-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-M-WHT-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-M-WHT-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-M-WHT-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-M-WHT-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-BLK-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-BLK-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-BLK-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-BLK-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-BLKNU-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-BLKNU-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-BLKNU-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-BLKNU-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-BLKNU-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-BLKNU-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-BLKNU-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-BLUE-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-BLUE-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-BLUE-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-BLUE-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-BLUE-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-BLUE-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-BLUE-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-BRN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-BRN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-BRN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-BRN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-BRNNU-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-BRNNU-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-BRNNU-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-BRNNU-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-BRNNU-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-BRNNU-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-BRNNU-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-GRN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-GRN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-GRN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-GRN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-GRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-GRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-GRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-GRY-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-GRY-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-GRY-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-GRY-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-GRY-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-GRY-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-GRY-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-HNY-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-HNY-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-HNY-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-HNY-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-HNY-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-HNY-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-HNY-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-OLV-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-OLV-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-OLV-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-OLV-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-OLV-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-OLV-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-OLV-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-ORG-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-ORG-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-ORG-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-ORG-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-ORG-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-ORG-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-ORG-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-RED-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-RED-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-RED-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-RED-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-RED-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-RED-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-RED-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-TAN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-TAN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-TAN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-TAN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-TAN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-TAN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-TAN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-TANNU-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-TANNU-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-TANNU-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-TANNU-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-TANNU-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-TANNU-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-TANNU-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-TUR-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-TUR-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-TUR-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-TUR-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-TUR-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-TUR-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-TUR-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-VIO-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-VIO-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-VIO-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-VIO-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-VIO-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-VIO-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-VIO-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-WHT-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-WHT-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-WHT-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-WHT-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-WHT-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-WHT-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-WHT-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-WHTNU-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-WHTNU-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-WHTNU-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-WHTNU-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-WHTNU-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-WHTNU-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-WHTNU-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-YELNU-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-YELNU-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-YELNU-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-YELNU-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-YELNU-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-YELNU-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8-W-YELNU-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "83-M-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "83-M-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "83-M-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "83-M-BLK-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "83-M-BLK-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "83-M-BLK-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "83-M-BLK-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "83-M-BLK-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "83-M-BLKALL-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "83-M-BLKALL-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "83-M-BLKALL-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "83-M-BLKALL-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "83-M-BLKALL-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "83-M-BLKALL-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "83-M-BLKALL-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "83-M-BLKALL-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "83-M-BLKOST-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "83-M-BLKOST-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "83-M-BLKOST-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "83-M-BLKOST-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "83-M-BLKOST-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "83-M-BLKOST-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "83-M-BLKOST-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "83-M-BLKOST-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "83-M-BLUE-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "83-M-BLUE-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "83-M-BLUE-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "83-M-BLUE-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "83-M-BLUE-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "83-M-BLUE-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "83-M-BLUE-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "83-M-BLUE-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "83-M-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "83-M-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "83-M-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "83-M-BRN-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "83-M-BRN-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "83-M-BRN-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "83-M-BRN-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "83-M-BRN-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "83-M-BRNALL-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "83-M-BRNALL-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "83-M-BRNALL-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "83-M-BRNALL-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "83-M-BRNALL-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "83-M-BRNALL-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "83-M-BRNALL-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "83-M-BRNALL-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "83-M-BRNOST-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "83-M-BRNOST-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "83-M-BRNOST-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "83-M-BRNOST-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "83-M-BRNOST-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "83-M-BRNOST-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "83-M-BRNOST-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "83-M-BRNOST-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "83-M-HNY-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "83-M-HNY-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "83-M-HNY-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "83-M-HNY-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "83-M-HNY-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "83-M-HNY-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "83-M-HNY-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "83-M-HNY-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "83-M-TAN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "83-M-TAN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "83-M-TAN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "83-M-TAN-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "83-M-TAN-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "83-M-TAN-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "83-M-TAN-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "83-M-TAN-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "83-M-WHT-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "83-M-WHT-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "83-M-WHT-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "83-M-WHT-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "83-M-WHT-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "83-M-WHT-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "83-M-WHT-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "83-M-WHT-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "85-M-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "85-M-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "85-M-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "85-M-BLK-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "85-M-BLK-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "85-M-BLK-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "85-M-BLK-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "85-M-BLK-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "85-M-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "85-M-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "85-M-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "85-M-BRN-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "85-M-BRN-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "85-M-BRN-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "85-M-BRN-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "85-M-BRN-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8CT-W-BLK-36": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "8CT-W-BLK-37": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "8CT-W-BLK-38": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "8CT-W-BLK-39": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "8CT-W-BLK-40": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "8CT-W-BLK-41": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "8CT-W-BLK-42": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "8CT-W-BRN-36": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "8CT-W-BRN-37": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "8CT-W-BRN-38": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "8CT-W-BRN-39": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "8CT-W-BRN-40": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "8CT-W-BRN-41": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "8CT-W-BRN-42": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "8V-M-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8V-M-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8V-M-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8V-M-BLK-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8V-M-BLK-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8V-M-BLK-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8V-M-BLK-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8V-M-BLK-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8V-M-BLUE-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8V-M-BLUE-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8V-M-BLUE-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8V-M-BLUE-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8V-M-BLUE-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8V-M-BLUE-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8V-M-BLUE-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8V-M-BLUE-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8V-M-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8V-M-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8V-M-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8V-M-BRN-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8V-M-BRN-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8V-M-BRN-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8V-M-BRN-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8V-M-BRN-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8V-W-BLK-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8V-W-BLK-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8V-W-BLK-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8V-W-BLK-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8V-W-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8V-W-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8V-W-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8V-W-BLUE-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8V-W-BLUE-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8V-W-BLUE-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8V-W-BLUE-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8V-W-BLUE-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8V-W-BLUE-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8V-W-BLUE-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8V-W-BRN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8V-W-BRN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8V-W-BRN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8V-W-BRN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8V-W-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8V-W-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "8V-W-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "9-M-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "9-M-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "9-M-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "9-M-BLK-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "9-M-BLK-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "9-M-BLK-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "9-M-BLK-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "9-M-BLK-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "9-M-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "9-M-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "9-M-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "9-M-BRN-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "9-M-BRN-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "9-M-BRN-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "9-M-BRN-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "9-M-BRN-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "91-M-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "91-M-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "91-M-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "91-M-BLK-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "91-M-BLK-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "91-M-BLK-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "91-M-BLK-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "91-M-BLK-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "91-M-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "91-M-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "91-M-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "91-M-BRN-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "91-M-BRN-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "91-M-BRN-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "91-M-BRN-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "91-M-BRN-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "91-W-BLK-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "91-W-BLK-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "91-W-BLK-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "91-W-BLK-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "91-W-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "91-W-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "91-W-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "91-W-BRN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "91-W-BRN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "91-W-BRN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "91-W-BRN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "91-W-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "91-W-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "91-W-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "91-W-HNY-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "91-W-HNY-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "91-W-HNY-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "91-W-HNY-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "91-W-HNY-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "91-W-HNY-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "91-W-HNY-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "91-W-RED-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "91-W-RED-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "91-W-RED-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "91-W-RED-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "91-W-RED-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "91-W-RED-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "91-W-RED-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "91-W-TAN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "91-W-TAN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "91-W-TAN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "91-W-TAN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "91-W-TAN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "91-W-TAN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "91-W-TAN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92-M-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92-M-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92-M-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92-M-BLK-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92-M-BLK-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92-M-BLK-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92-M-BLK-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92-M-BLK-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92-M-BLKTN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92-M-BLKTN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92-M-BLKTN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92-M-BLKTN-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92-M-BLKTN-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92-M-BLKTN-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92-M-BLKTN-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92-M-BLKTN-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92-M-BLKWH-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92-M-BLKWH-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92-M-BLKWH-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92-M-BLKWH-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92-M-BLKWH-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92-M-BLKWH-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92-M-BLKWH-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92-M-BLKWH-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92-M-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92-M-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92-M-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92-M-BRN-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92-M-BRN-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92-M-BRN-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92-M-BRN-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92-M-BRN-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92-W-BLK-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92-W-BLK-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92-W-BLK-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92-W-BLK-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92-W-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92-W-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92-W-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92-W-BLKTN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92-W-BLKTN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92-W-BLKTN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92-W-BLKTN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92-W-BLKTN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92-W-BLKTN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92-W-BLKTN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92-W-BRN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92-W-BRN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92-W-BRN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92-W-BRN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92-W-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92-W-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92-W-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92-W-TAN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92-W-TAN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92-W-TAN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92-W-TAN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92-W-TAN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92-W-TAN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92-W-TAN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92B-M-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92B-M-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92B-M-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92B-M-BLK-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92B-M-BLK-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92B-M-BLK-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92B-M-BLK-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92B-M-BLK-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92B-M-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92B-M-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92B-M-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92B-M-BRN-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92B-M-BRN-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92B-M-BRN-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92B-M-BRN-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92B-M-BRN-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92B-W-BLK-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92B-W-BLK-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92B-W-BLK-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92B-W-BLK-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92B-W-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92B-W-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92B-W-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92B-W-BRN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92B-W-BRN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92B-W-BRN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92B-W-BRN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92B-W-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92B-W-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92B-W-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92B-W-TAN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92B-W-TAN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92B-W-TAN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92B-W-TAN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92B-W-TAN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92B-W-TAN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92B-W-TAN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92V-M-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92V-M-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92V-M-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92V-M-BLK-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92V-M-BLK-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92V-M-BLK-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92V-M-BLK-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92V-M-BLK-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92V-M-BLUE-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92V-M-BLUE-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92V-M-BLUE-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92V-M-BLUE-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92V-M-BLUE-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92V-M-BLUE-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92V-M-BLUE-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92V-M-BLUE-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92V-M-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92V-M-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92V-M-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92V-M-BRN-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92V-M-BRN-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92V-M-BRN-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92V-M-BRN-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "92V-M-BRN-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "93-M-BLUE-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "93-M-BLUE-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "93-M-BLUE-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "93-M-BLUE-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "93-M-BLUE-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "93-M-BLUE-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "93-M-BLUE-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "93-M-BLUE-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "93V-M-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "93V-M-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "93V-M-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "93V-M-BLK-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "93V-M-BLK-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "93V-M-BLK-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "93V-M-BLK-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "93V-M-BLK-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "93V-M-BLUE-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "93V-M-BLUE-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "93V-M-BLUE-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "93V-M-BLUE-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "93V-M-BLUE-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "93V-M-BLUE-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "93V-M-BLUE-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "93V-M-BLUE-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "95-M-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "95-M-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "95-M-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "95-M-BLK-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "95-M-BLK-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "95-M-BLK-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "95-M-BLK-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "95-M-BLK-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "95-M-BLKWH-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "95-M-BLKWH-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "95-M-BLKWH-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "95-M-BLKWH-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "95-M-BLKWH-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "95-M-BLKWH-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "95-M-BLKWH-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "95-M-BLKWH-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "95-M-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "95-M-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "95-M-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "95-M-BRN-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "95-M-BRN-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "95-M-BRN-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "95-M-BRN-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "95-M-BRN-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "95-W-BLK-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "95-W-BLK-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "95-W-BLK-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "95-W-BLK-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "95-W-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "95-W-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "95-W-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "95-W-BLKWH-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "95-W-BLKWH-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "95-W-BLKWH-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "95-W-BLKWH-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "95-W-BLKWH-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "95-W-BLKWH-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "95-W-BLKWH-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "95-W-BRN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "95-W-BRN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "95-W-BRN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "95-W-BRN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "95-W-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "95-W-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "95-W-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "95D-W-BLK-36": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "95D-W-BLK-37": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "95D-W-BLK-38": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "95D-W-BLK-39": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "95D-W-BLK-40": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "95D-W-BLK-41": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "95D-W-BLK-42": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "95D-W-BRN-36": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "95D-W-BRN-37": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "95D-W-BRN-38": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "95D-W-BRN-39": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "95D-W-BRN-40": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "95D-W-BRN-41": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "95D-W-BRN-42": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "95D-W-GRN-36": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "95D-W-GRN-37": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "95D-W-GRN-38": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "95D-W-GRN-39": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "95D-W-GRN-40": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "95D-W-GRN-41": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "95D-W-GRN-42": {
    "Size": "TRUE",
    "Fit": "Wide",
    "Arch": "High"
  },
  "99-M-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "99-M-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "99-M-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "99-M-BLK-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "99-M-BLK-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "99-M-BLK-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "99-M-BLK-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "99-M-BLK-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "99-M-BRN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "99-M-BRN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "99-M-BRN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "99-M-BRN-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "99-M-BRN-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "99-M-BRN-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "99-M-BRN-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "99-M-BRN-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "99-M-HNY-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "99-M-HNY-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "99-M-HNY-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "99-M-HNY-43": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "99-M-HNY-44": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "99-M-HNY-45": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "99-M-HNY-46": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "99-M-HNY-47": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A10-W-NTRL-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A10-W-NTRL-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A10-W-NTRL-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A10-W-NTRL-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A10-W-NTRL-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A10-W-NTRL-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A10-W-NTRL-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A10-W-TAN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A10-W-TAN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A10-W-TAN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A10-W-TAN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A10-W-TAN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A10-W-TAN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A10-W-TAN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A11-W-BLK-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A11-W-BLK-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A11-W-BLK-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A11-W-BLK-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A11-W-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A11-W-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A11-W-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A11-W-NTRL-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A11-W-NTRL-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A11-W-NTRL-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A11-W-NTRL-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A11-W-NTRL-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A11-W-NTRL-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A11-W-NTRL-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A11-W-TAN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A11-W-TAN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A11-W-TAN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A11-W-TAN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A11-W-TAN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A11-W-TAN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A11-W-TAN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A15-W-BLK-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A15-W-BLK-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A15-W-BLK-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A15-W-BLK-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A15-W-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A15-W-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A15-W-TAN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A15-W-TAN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A15-W-TAN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A15-W-TAN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A15-W-TAN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A15-W-TAN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A16-W-BLK-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A16-W-BLK-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A16-W-BLK-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A16-W-BLK-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A16-W-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A16-W-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A16-W-TAN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A16-W-TAN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A16-W-TAN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A16-W-TAN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A16-W-TAN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A16-W-TAN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A20-W-BLK-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A20-W-BLK-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A20-W-BLK-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A20-W-BLK-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A20-W-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A20-W-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A20-W-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A3-W-BLK-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A3-W-BLK-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A3-W-BLK-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A3-W-BLK-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A3-W-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A3-W-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A3-W-TAN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A3-W-TAN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A3-W-TAN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A3-W-TAN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A3-W-TAN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A3-W-TAN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A41-W-BLK-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A41-W-BLK-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A41-W-BLK-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A41-W-BLK-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A41-W-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A41-W-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A41-W-BLUE-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A41-W-BLUE-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A41-W-BLUE-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A41-W-BLUE-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A41-W-BLUE-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A41-W-BLUE-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A41-W-NTRL-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A41-W-NTRL-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A41-W-NTRL-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A41-W-NTRL-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A41-W-NTRL-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A41-W-NTRL-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A41-W-TAN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A41-W-TAN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A41-W-TAN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A41-W-TAN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A41-W-TAN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A41-W-TAN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A5-W-BLK-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A5-W-BLK-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A5-W-BLK-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A5-W-BLK-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A5-W-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A5-W-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A5-W-NTRL-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A5-W-NTRL-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A5-W-NTRL-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A5-W-NTRL-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A5-W-NTRL-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A5-W-NTRL-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A7-W-BLK-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A7-W-BLK-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A7-W-BLK-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A7-W-BLK-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A7-W-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A7-W-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A7-W-NTRL-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A7-W-NTRL-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A7-W-NTRL-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A7-W-NTRL-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A7-W-NTRL-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A7-W-NTRL-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A8-W-BLK-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A8-W-BLK-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A8-W-BLK-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A8-W-BLK-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A8-W-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A8-W-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A8-W-NTRL-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A8-W-NTRL-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A8-W-NTRL-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A8-W-NTRL-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A8-W-NTRL-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A8-W-NTRL-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A8-W-TAN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A8-W-TAN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A8-W-TAN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A8-W-TAN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A8-W-TAN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "A8-W-TAN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "D11-W-BLK-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "D11-W-BLK-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "D11-W-BLK-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "D11-W-BLK-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "D11-W-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "D11-W-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "D11-W-TAN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "D11-W-TAN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "D11-W-TAN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "D11-W-TAN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "D11-W-TAN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "D11-W-TAN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "S2-W-BLK-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "S2-W-BLK-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "S2-W-BLK-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "S2-W-BLK-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "S2-W-BLK-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "S2-W-BLK-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "S2-W-BLK-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "S2-W-NTRL-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "S2-W-NTRL-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "S2-W-NTRL-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "S2-W-NTRL-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "S2-W-NTRL-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "S2-W-NTRL-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "S2-W-NTRL-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "S2-W-TAN-36": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "S2-W-TAN-37": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "S2-W-TAN-38": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "S2-W-TAN-39": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "S2-W-TAN-40": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "S2-W-TAN-41": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "S2-W-TAN-42": {
    "Size": "TRUE",
    "Fit": "Standard",
    "Arch": "Standard"
  },
  "S21-W-BLK-36": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "S21-W-BLK-37": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "S21-W-BLK-38": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "S21-W-BLK-39": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "S21-W-BLK-40": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  },
  "S21-W-BLK-41": {
    "Size": "TRUE",
    "Fit": "Narrow",
    "Arch": "Standard"
  }
};